module.exports = "<audio class=\"lpview_audio_tag\" preload=\"auto\"></audio>";